/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const a = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu", "Minggu"], e = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"], n = "Tahunan", t = "Tahun", s = "Bulan", i = "Minggu", r = "Hari", d = "Hari Ini", u = "Tidak Ada Kegiatan", g = "Sepanjang Hari", m = "Hapus", o = "Tambah Kegiatan", M = "dddd, D MMMM YYYY", l = { weekDays: a, months: e, years: "Tahunan", year: "Tahun", month: "Bulan", week: "Minggu", day: "Hari", today: "Hari Ini", noEvent: "Tidak Ada Kegiatan", allDay: "Sepanjang Hari", deleteEvent: "Hapus", createEvent: "Tambah Kegiatan", dateFormat: "dddd, D MMMM YYYY" };
export {
  g as allDay,
  o as createEvent,
  M as dateFormat,
  r as day,
  l as default,
  m as deleteEvent,
  s as month,
  e as months,
  u as noEvent,
  d as today,
  i as week,
  a as weekDays,
  t as year,
  n as years
};
